import _ from "lodash";
import { action, computed, extendObservable } from "mobx";
import moment from "moment";
import { DateFormat } from "../utils/format";

class QuestionableCallsStore {
  constructor(setiApi) {
    this.setiApi = setiApi;
    this.data = {};
    this.errors = {};

    extendObservable(this, {
      isLoading: true,
      pitchTypes: [],
      hardballsCheckboxGroup: ["hardballs"],
      venueIds: "17",
      startDate: moment()
        .subtract(1, "year")
        .format(DateFormat.PITCH_CRITERIA_DATE),
      endDate: moment().format(DateFormat.PITCH_CRITERIA_DATE),
      lastNGames: "",
      lowZRange: "2.0",
      highZRange: "3.0",
      selectedBatterSide: "B",
      selectedTimeOfDay: "B",
      shiftBoundary: "0.3",
      shiftStep: "0.01",
      hardballsOnly: computed(() => this.hardballsCheckboxGroup.length === 1),
      venueIdsParam: computed(
        () => (_.isEmpty(this.venueIds) ? [] : this.venueIds.split(","))
      ),
      params: computed(() => ({
        pitchCriteria: {
          lastNGames: this.lastNGames,
          pitchTypes: this.pitchTypes,
          hardballsOnly: this.hardballsOnly,
          dayNightCode: this.selectedTimeOfDay,
          batterSide: this.selectedBatterSide,
          dateRange: {
            low: this.startDate,
            high: this.endDate,
            inclusive: true
          },
          zrange: {
            low: this.lowZRange,
            high: this.highZRange,
            inclusive: true
          },
          venueIds: this.venueIdsParam
        },
        modelArgs: {
          shiftBoundary: this.shiftBoundary,
          shiftStep: this.shiftStep
        }
      })),
      updateVenueIds: action(value => {
        this.venueIds = value;
      }),
      updateStartDate: action(value => {
        this.startDate = value;
      }),
      updateEndDate: action(value => {
        this.endDate = value;
      }),
      updateLastNGames: action(value => {
        this.lastNGames = value;
      }),
      updateLowZRange: action(value => {
        this.lowZRange = value;
      }),
      updateHighZRange: action(value => {
        this.highZRange = value;
      }),
      updateShiftBoundary: action(value => {
        this.shiftBoundary = value;
      }),
      updateShiftStep: action(value => {
        this.shiftStep = value;
      }),
      updatePitchTypes: action(values => {
        this.pitchTypes = values;
      }),
      updateHardballs: action(values => {
        this.hardballsCheckboxGroup = values;
      }),
      updateSelectedBatterSide: action(value => {
        this.selectedBatterSide = value;
      }),
      updateSelectedTimeOfDay: action(value => {
        this.selectedTimeOfDay = value;
      }),
      fetchData: action(() => {
        this.isLoading = true;
        this.setiApi.fetchQuestionableCallsData(this.params).then(data => {
          this.data = data;
          this.isLoading = false;
        });
      })
    });
  }
}

export default QuestionableCallsStore;



// WEBPACK FOOTER //
// ./src/stores/questionableCallsStore.js